export default __webpack_public_path__ + "79b3bd06aa06d57b46db6a3072a9d383.svg";